import Http from "../Http";
import { INSPECTION_URL } from "../Helper";

export function getConsultantProfileData(profile_id) {
    return (dispatch) =>
      new Promise((resolve, reject) => {
        Http.get(INSPECTION_URL + 'get_consultant_profile/' + (profile_id || 0))
          .then((res) => {
            return resolve(res.data);
          })
          .catch((err) => {
            return reject(err);
          });
      });
}

export function updateConsultantProfile(values) {
    return (dispatch) =>
      new Promise((resolve, reject) => {
        Http.post(INSPECTION_URL + 'update_consultant_profile/', values)
          .then((res) => {
            return resolve(res.data);
          })
          .catch((err) => {
            return reject(err);
          });
      });
}
